import Bag from "../images/bag.svg";
import Cart from "../images/cart.svg";
import Coin from "../images/coin.svg";
import Open from "../images/open.svg";
import "./DetailsHome.css";

function DetailsHome() {
  return (
    <div className="container mt-5 mb-5">
      <hr className="fw-bold mb-5" />
      <div className="row mt-5">
        <div className="col-6 col-md-3 mb-2">
          <div>
            <small>
              <img className="icon" src={Bag} alt="bag"></img>
            </small>
            <p className="fw-bold mt-4">EASY PURCHASE</p>
            <span>100% safe</span>
          </div>
        </div>
        <div className="col-6 col-md-3">
          {" "}
          <div>
            <small>
              <img className="icon" src={Cart} alt="cart"></img>
            </small>
            <p className="fw-bold mt-4">ONLINE PURCHASE</p>
            <span>Free shipping</span>
          </div>
        </div>
        <div className="col-6 col-md-3 mb-2">
          {" "}
          <div>
            <small>
              <img className="icon" src={Coin} alt="coin"></img>
            </small>
            <p className="fw-bold mt-4">WIDE VARIETY OF PAYMENT METHODS</p>
            <span>Choose</span>
          </div>
        </div>
        <div className="col-6 col-md-3 mb-2">
          {" "}
          <div>
            <small>
              <img className="icon" src={Open} alt="open"></img>
            </small>
            <p className="fw-bold mt-4">NEW STORE</p>
            <span>Visit us</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DetailsHome;
